import getPaginationWidth from '~/shared/utils/getPaginationWidth.utils'
import { formatThousands } from '~/utils'

import Spacer from './Spacer'

export default function PagePicker({
  isActivePage,
  isDivider,
  onSetPageClick,
  page,
  squreDesign = false,
}: {
  isActivePage: boolean
  isDivider?: boolean
  onSetPageClick?: (newPage: number) => void
  page: number
  squreDesign?: boolean
}): React.ReactElement {
  if (isDivider) {
    return <Spacer />
  }
  const onClickHandler = (): void => {
    if (onSetPageClick) onSetPageClick(page)
  }

  return (
    <button
      aria-current="page"
      className={`z-10 relative flex items-center justify-center duration-300 transition-colors ${
        squreDesign
          ? `min-w-11.5 h-10 ${
              isActivePage
                ? 'bg-gradient-purple-light-top text-white font-medium'
                : 'bg-purple-dark-violet hover:bg-gradient-purple-light-top'
            }`
          : `rounded-full h-6 sm:h-10 ${
              isActivePage ? 'bg-purple text-white font-medium border-2 border-white' : 'hover:bg-purple-light bg-white'
            }`
      } text-sm ${getPaginationWidth(page + 1)}`}
      key={page}
      onClick={onClickHandler}
    >
      {formatThousands(page + 1)}
    </button>
  )
}
